export default __webpack_public_path__ + "static/bg_factory-2f9ed2d10700b72cc2065e9d4cd0a7a4.jpg";